import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import * as yup from 'yup';
import { Formik } from 'formik';
import DropdownMain from '../../../../components/dropdown-main/DropdownMain';
import './admin-role-create-form.scss';

const NAME_REGEX = /^[^~`!@#$%^*(){}:;"<>?/[\]\|\\]*$/i;

const AdminRoleCreateForm = ({loaded, role, isEdit, departments, selectedDepartment, setSelectedDepartment, saveRole, onCancel}) => {

    const onKeyDown = (keyEvent) => {
        if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
            keyEvent.preventDefault();
          }
    }

    const enterKeySubmission = (keyEvent, submitForm) => {
        if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
            submitForm && submitForm();
        }
    }

    const enterKeyCancel =(keyEvent) => {
        if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
            onCancel()
        }
    }

    return (
        <Formik
            key={loaded}
            validationSchema={yup.object({
                Name: yup.string().max(50, "Role name must be under 50 characters").matches(NAME_REGEX, "Please do not enter any special characters in role name").required("Role Name Required"),
                Company: yup.number().moreThan(0, "Invalid Department").required("Department Required"),
                SuperAdmin: yup.boolean().required("Is Super Admin"),
                Admin: yup.boolean().required("Needs Admin Role"),
                Description: yup.string().max(3000, "Description must be under 3000 characters").nullable(),
                Active: yup.boolean().required("Need to Be Active"),
            })}
            onSubmit={(values,actions) => {
                saveRole(values,actions)
            }}
            initialValues={role}
        >
            {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                errors,
                setFieldValue,
                setFieldTouched,
                isSubmitting,
                submitForm
            }) => (
                    <Form className="role-creation-container" onSubmit={handleSubmit} onKeyDown={(e) => onKeyDown(e)}>
                        <Form.Row className="left-row">
                            <Form.Group className="role-name">
                                <Form.Label>Role Name <span style={{color: 'red'}}> * </span></Form.Label>
                                <Form.Control
                                    id={"Name"}
                                    name={"Name"}
                                    placeholder="Enter Role Name"
                                    value={values.Name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.Name && errors.Name}
                                />
                                <Form.Control.Feedback type="invalid" className="inline-error">{errors.Name}</Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group className="role-department">
                                <Form.Label>Department <span style={{color: 'red'}}> * </span></Form.Label>
                                <DropdownMain
                                    values={departments && departments.map(department => {
                                        return {
                                            id: department.Id,
                                              name:
                                              department.Name +
                                              (department.Active ? "" : " [Inactive]"),
                                            disabled: !department.Active,
                                          };
                                    })}
                                    dropdownButtonText={"Select a Department"}
                                    onSelect={(selectedValue) => {
                                        setFieldValue("Company", selectedValue.id);
                                        setFieldTouched("Company");
                                        setSelectedDepartment(selectedValue)
                                    }}
                                    currentSelected={selectedDepartment}
                                />
                                {!selectedDepartment && touched.Company && <div className="inline-error department-error">{errors.Company}</div>}
                            </Form.Group>
                            <Form.Group className="role-edit-permission">
                                <div>Permission <span style={{color: 'red'}}> * </span></div>
                                <Form.Check
                                    id="SuperAdmin"
                                    className="role-super-admin-status"
                                    type="checkbox"
                                    label="Super-Admin"
                                    name="SuperAdmin"
                                    checked={values.SuperAdmin}
                                    onChange={(e) => {handleChange(e); setFieldValue("SuperAdmin", true); setFieldValue("Admin", false)}}
                                />
                                <Form.Check
                                    id="Admin"
                                    className="role-admin-status"
                                    type="checkbox"
                                    label="Admin"
                                    checked={values.Admin}
                                    onChange={(e) => {handleChange(e); setFieldValue("SuperAdmin", false); setFieldValue("Admin", true)}}
                                />
                                <Form.Check
                                    id="isUserRole"
                                    className="role-user-status"
                                    type="checkbox"
                                    label="User"
                                    checked={!values.Admin && !values.SuperAdmin}
                                    onChange={(e) => {handleChange(e); setFieldValue("SuperAdmin", false); setFieldValue("Admin", false)}}
                                />
                                <Form.Control.Feedback type="invalid">{errors.SuperAdmin}</Form.Control.Feedback>
                            </Form.Group>
                        </Form.Row>
                        <Form.Row className="right-row">
                            <Form.Group className="role-description">
                                <Form.Label>Description</Form.Label>
                                <Form.Control
                                    id="Description"
                                    as="textarea"
                                    className="role-textarea"
                                    placeholder="Enter Description"
                                    value={values.Description}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    isInvalid={touched.Description && errors.Description}
                                />
                                <Form.Control.Feedback type="invalid" className="inline-error">{errors.Description}</Form.Control.Feedback>
                            </Form.Group>
                            {
                                isEdit ?
                                    <Form.Group className="role-edit-permission">
                                        <Form.Label className="status-title">Role Status</Form.Label>
                                        <Form.Check
                                            id="Active"
                                            type="checkbox"
                                            label="Active"
                                            className="role-super-admin-status"
                                            checked={values.Active}
                                            onChange={(e) => {setFieldValue("Active", true)}}
                                        />
                                        <Form.Check
                                            id="isNotActive"
                                            type="checkbox"
                                            label="Inactive"
                                            className="role-admin-status"
                                            checked={!values.Active}
                                            onChange={(e) => {setFieldValue("Active", false)}}
                                        />
                                    </Form.Group>
                                    : <></>
                            }
                        </Form.Row>
                        <Form.Row>
                            <ButtonToolbar className="role-btn-container">
                                <Button
                                className="btn-wide"
                                type="submit"
                                onKeyDown= {(keyEvent) => enterKeySubmission(keyEvent, submitForm)}
                                disabled={isSubmitting}
                                >{isEdit ? "Save" : "Create"}</Button>
                                <Button onKeyDown = {(keyEvent) => enterKeyCancel(keyEvent)} className="btn-wide btn-outlined" onClick={() => onCancel()} >Cancel</Button>
                            </ButtonToolbar>
                        </Form.Row>
                    </Form>
                )}
        </Formik>
    )
}

AdminRoleCreateForm.propTypes = {
    loaded: PropTypes.bool.isRequired, 
    role: PropTypes.object.isRequired,
    isEdit: PropTypes.bool.isRequired, 
    departments: PropTypes.array.isRequired, 
    selectedDepartment: PropTypes.object.isRequired,
    setSelectedDepartment: PropTypes.func.isRequired, 
    saveRole: PropTypes.func.isRequired, 
    onCancel: PropTypes.func.isRequired
};

export default AdminRoleCreateForm;